import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  CopyOutlined,
  CheckOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

import CopyIcon from '../../../../components/icons/copy';
import SuccessIcon from '../../../../components/icons/success';
import * as styles from './index.module.scss';

interface CopyButtonProps {
  textToCopy: string;
}
const CopyButton = ({ textToCopy }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className={styles.copied}>
      <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className={styles.button}
        >
          {copied ? (
            <motion.div
              className={styles.icon}
              initial={{ opacity: 0, display: 'none' }}
              animate={{ opacity: 1, display: 'inline-block' }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <SuccessIcon />
            </motion.div>
          ) : (
            <motion.div
              className={styles.icon}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <CopyIcon />
            </motion.div>
          )}
        </motion.button>
      </CopyToClipboard>
      {copied && (
        <motion.span
          className={styles.copiedText}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          Copied
        </motion.span>
      )}
    </div>
  );
};

export default CopyButton;
